// extracted by mini-css-extract-plugin
export default {"step-indicator":"StepIndicator_step-indicator__VbP04"};